const mdSysShape = {
  corner: {
    none: '0px',
    extraSmall: '4px',
    extraSmallTop: '4px 4px 0 0',
    small: '8px',
    medium: '12px',
    large: '16px',
    largeEnd: '0 16px 16px 0',
    largeTop: '16px 16px 0 0',
    extraLarge: '28px',
    extraLargeTop: '28px 28px 0 0',
    full: '100px'
  }
};
export default mdSysShape;